import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  JsonpClientBackend,
} from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { ArbolMenu } from "../models/arbol-menu";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";

const endpoint = environment.apiMenuArbolUrl;

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};

@Injectable({
  providedIn: "root",
})
export class MenuArbolService {

  private defaultIdMenu:string;
  constructor(private httpClient: HttpClient) {
    this.defaultIdMenu = "1";
  }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

   loadMenuArbolTree(id_menu) {
     const idMenu = id_menu?id_menu:this.defaultIdMenu;
    return this.httpClient.get<any>(endpoint + `/display/${idMenu}`).pipe(map(this.extractData));
  }
}
